import React from "react"

import { FileUpload } from "shared/ui/file-upload/FileUpload"

import { ProductDeliveryTimeUploadModel } from "./model/useProductDeliveryTimeUploadModel"
import "./styles/_product-delivery-time-upload.scss"

export interface ProductDeliveryTimeUploadViewModel
  extends ProductDeliveryTimeUploadModel {}

const ALLOWED_DATA_FORMATS = [".csv"]

export const ProductDeliveryTimeUploadView = React.memo(
  ({
    fileLabel,
    inputLabel,
    file,
    isLoading,
    onUpload
  }: ProductDeliveryTimeUploadViewModel) => {
    return (
      <FileUpload.Root
        className="product-delivery-time-upload"
        isLoading={isLoading}
        files={file}
        onUpload={onUpload}
        dataFormats={ALLOWED_DATA_FORMATS}
        multiple={false}
      >
        <div className="product-delivery-time-upload__file-label">
          {fileLabel}
        </div>
        <FileUpload.List className="product-delivery-time-upload__file" />
        <div className="product-delivery-time-upload__input-label">
          {inputLabel}
        </div>
        <FileUpload.Input className="product-delivery-time-upload__input" />
      </FileUpload.Root>
    )
  }
)
